import { render, staticRenderFns } from "./CatalogDetailsPage.vue?vue&type=template&id=7fffecf8&scoped=true&"
import script from "./CatalogDetailsPage.vue?vue&type=script&lang=js&"
export * from "./CatalogDetailsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fffecf8",
  null
  
)

export default component.exports